import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { initializeFirebase } from './lib/firebase';
import { installPreloadErrorGuard } from '@mbbe/config';
import { ChunkLoadBoundary, ChunkRecoveryProvider, ErrorBoundary, ToastProvider } from '@mbbe/ui';
import { adminDrafts, adminRecovery } from './lib/chunkRecovery';
import { createAdminQueryClient } from './lib/queryClient';
import './index.css';

// Stale-deploy guard: a tab opened before a deploy holds an index.html that
// references hashed chunks which no longer exist, so lazy-route imports 404.
// The shared recovery controller reloads automatically only when no screen holds
// unsaved or pending work, only a bounded number of times, and never when it cannot
// record the attempt. Otherwise it shows an accessible update prompt (see ChunkRecoveryProvider).
installPreloadErrorGuard(adminRecovery);

try {
  initializeFirebase();
} catch (error) {
  console.error('Firebase initialization failed:', error);
}

const queryClient = createAdminQueryClient();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <ChunkRecoveryProvider controller={adminRecovery} drafts={adminDrafts} language="tr">
            <AuthProvider>
              <BrowserRouter>
                <ChunkLoadBoundary>
                  <App />
                </ChunkLoadBoundary>
              </BrowserRouter>
            </AuthProvider>
          </ChunkRecoveryProvider>
        </ToastProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
